(function($) {

    function getCartCount() {
        const $cartCount = $('.cart-badge');
        const $miniCartData = $('.card-menu-hover');

        $.ajax({
            url: window.ajaxurl,
            method: 'POST',
            data: {
                action: 'get_cart_count'
            },
            success(response) {
                if (!response?.success) return;

                const { miniCart, empty, count } = response.data || {};

                $miniCartData.empty().append(miniCart || '');

                if (empty) {
                    $cartCount.hide();
                    return;
                }

                $cartCount.text(count ?? '').show();
            }
        });
    }

    getCartCount();


})(jQuery);